import * as React from 'react';
import ReactGA from 'react-ga4';
// @ts-ignore:types
import LinkedInTag from 'react-linkedin-insight';

import { properties } from 'risesharp-ui';

// see https://github.com/react-ga/react-ga/wiki/React-Router-v4-withTracker
// also see https://stackoverflow.com/q/51025967
const withTracker = (WrappedComponent: any, options = {}) => {
  return class extends React.Component<any, any> {
    componentDidMount() {
      const page = this.props.location.pathname + this.props.location.search;
      // console.log('withTracker cdm', page);
      this.trackPage(page);
    }

    componentDidUpdate(prevProps: any) {
      const currentPage = prevProps.location.pathname + prevProps.location.search;
      const nextPage = this.props.location.pathname + this.props.location.search;
      if (currentPage !== nextPage) {
        // console.log('withTracker cwrp', nextPage);
        this.trackPage(nextPage);
      }
    }

    render() {
      return <WrappedComponent {...this.props} />;
    }

    private trackPage(page: any) {
      if (properties.google_analytics_id) {
        ReactGA.send({ hitType: 'pageview', page });
      }
    }
  };
};

export default withTracker;
